import axios from "axios";
import React, {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import leftArrow from "../../../assets/images/common/left-arrow.svg";
import blueArrow from "../../../assets/images/inquiry/detail/blue-arrow.svg";
import * as API_URL from "../../../constants/ApiUrl";
import * as QUERY from "../../../constants/query/Inquiry.query";
import * as Routes from "../../../constants/Routes";
import Popup from "../../common/popup/Popup";
import {PopupProps} from "../../common/popup/Popup.props";
import {getInquiryTypeName} from "../constants/SearchType";
import {CompleteDto} from "../dto/CompleteDto";
import {DetailInquiryDto, InitialDetailInquiryDto} from "../dto/InquiryDto";
import "./style.css";

export default function Detail() {
    const navigate = useNavigate();
    const location = useLocation();

    const [popupProps, setPopupProps] = useState<PopupProps | null>(null);
    const [detailInquiryDto, setDetailInquiryDto] = useState<DetailInquiryDto>(InitialDetailInquiryDto);
    const [completeDto, setCompleteDto] = useState<CompleteDto>({reply: ""});

    useEffect(() => {
        if (location.state !== null && location.state !== undefined) {
            axios.post(API_URL.GRAPHQL, {query: QUERY.GET(location.state.seq)})
                .then(response => {
                    setDetailInquiryDto(response.data.data.getInquiry);
                });
        }
    }, [location.state]);

    const handleBackButtonClick = () => {
        navigate(Routes.INQUIRY);
    }

    const handleContentChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setCompleteDto({
            ...completeDto,
            reply: event.target.value.replace(/\n/g, "<br/>")
        });
    }

    const handleCompleteButtonClick = () => {
        if (completeDto.reply === "") {
            setPopupProps({
                subject: "문의사항 처리완료",
                message1: "답변 내용을 입력해 주세요.",
                message2: null,
                buttonName: "확인",
                onConfirm: () => setPopupProps(null),
                useCloseButton: false,
                onClose: () => {}
            });
            return;
        }

        setPopupProps({
            subject: "처리 완료하시겠습니까?",
            message1: "등록된 답변은 수정이 불가능합니다.",
            message2: "처리 완료하시겠습니까?",
            buttonName: "처리 완료",
            onConfirm: () => complete(),
            useCloseButton: true,
            onClose: () => setPopupProps(null)
        });
    }

    const complete = () => {
        axios.post(API_URL.COMPLETE_INQUIRY(location.state.seq), completeDto)
            .then(() => {
                navigate(Routes.INQUIRY);
            });
    }

    return (
        <>
            <div className="inquiry-detail">
                <main className="wrapper">
                    <div className="inquiry-detail-body">
                        <div className="inquiry-detail-title">
                            <div className="left">
                                <button className="arrow" data-testid="backButton" onClick={handleBackButtonClick}>
                                    <img src={leftArrow} alt="arrow"/>
                                </button>
                                <div className="text">
                                    문의상세
                                </div>
                                {
                                    detailInquiryDto.inquiryDto.isCompleted && (
                                        <div className="answer-title" data-testid="completeMark">
                                            처리완료
                                        </div>
                                    )
                                }
                            </div>
                            {
                                !detailInquiryDto.inquiryDto.isCompleted && (
                                    <div className="right">
                                        <button className="complete-button" data-testid="completeButton" onClick={handleCompleteButtonClick}>
                                            처리완료
                                        </button>
                                    </div>
                                )
                            }
                        </div>
                        <div className="inquiry-detail-box">
                            <div className="inquiry-content">
                                <div className="inquiry-box-top">
                                    <div className="inquiry-content-wrapper">
                                        <div className="title">
                                            분류
                                        </div>
                                        <div className="text">
                                            {getInquiryTypeName(detailInquiryDto.inquiryDto.type)}
                                        </div>
                                    </div>
                                    <div className="inquiry-content-wrapper">
                                        <div className="title">
                                            종류
                                        </div>
                                        <div className="text">
                                            {detailInquiryDto.detailType}
                                        </div>
                                    </div>
                                </div>
                                <div className="inquiry-box-bottom">
                                    <div className="inquiry-content-wrapper">
                                        <div className="title">
                                            회원여부
                                        </div>
                                        <div className="text">
                                            {detailInquiryDto.inquiryDto.isMember ? "회원" : "비회원"}
                                        </div>
                                    </div>
                                    <div className="inquiry-content-wrapper">
                                        <div className="title">
                                            사용자
                                        </div>
                                        <div className="text">
                                            {detailInquiryDto.inquiryDto.name}
                                        </div>
                                    </div>
                                    <div className="inquiry-content-wrapper">
                                        <div className="title">
                                            연락처
                                        </div>
                                        <div className="text">
                                            {detailInquiryDto.inquiryDto.phone}
                                        </div>
                                    </div>
                                    <div className="inquiry-content-wrapper">
                                        <div className="title">
                                            이메일
                                        </div>
                                        <div className="text">
                                            {detailInquiryDto.inquiryDto.email}
                                        </div>
                                    </div>
                                    <div className="inquiry-content-wrapper">
                                        <div className="title">
                                            문의 일시
                                        </div>
                                        <div className="text">
                                            {detailInquiryDto.inquiryDto.createdAt}
                                        </div>
                                    </div>
                                    <div className="inquiry-content-wrapper content-wrapper">
                                        <div className="title">
                                            문의내용
                                        </div>
                                        <div className="text" dangerouslySetInnerHTML={{__html: detailInquiryDto.content}}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            detailInquiryDto.inquiryDto.isCompleted? (
                                <div className="inquiry-detail-box" data-testid="replyWrapper">
                                    <div className="answer-title answer-complete-title">
                                        <div className="img-wrapper">
                                            <img src={blueArrow} alt="arrow"/>
                                        </div>
                                        <span>
                                            답변
                                        </span>
                                    </div>
                                    <div className="inquiry-content-wrapper">
                                        <div className="text reply-wrapper"
                                             dangerouslySetInnerHTML={{__html: detailInquiryDto.inquiryDto.reply}}
                                             data-testid="replyContent"
                                        ></div>
                                    </div>
                                </div>
                            ) : (
                                <div className="inquiry-detail-box" data-testid="replyWriteWrapper">
                                    <div className="answer-title">
                                        답변 작성
                                    </div>
                                    <textarea className="text-box"
                                              placeholder="답변을 입력해 주세요."
                                              onChange={handleContentChange}
                                    />
                                </div>
                            )
                        }
                    </div>
                </main>
            </div>
            {
                popupProps && (
                    <Popup data={popupProps}/>
                )
            }
        </>
    );
}